import { useQuery } from '@tanstack/react-query';

import { GET_STRIPE_LINK } from '../../contracts';
import { getStripeLink } from '../api/billing';

export function useQueryStripeLink(
  enabled = true,
  options?: { onFetchError?: (error: unknown) => void }
) {
  return useQuery({
    queryKey: [GET_STRIPE_LINK],
    enabled,
    queryFn: async () => {
      try {
        const { data } = await getStripeLink();
        return data;
      } catch (error) {
        options?.onFetchError?.(error);
        throw new Error();
      }
    },
    staleTime: 5 * 60 * 1000,
  });
}
